export const MOBILE_SCREEN_WIDTH = 1008;

export const BASE_URL = process.env.SERVER_URL != null ? process.env.SERVER_URL : "https://admin.et-alier.com";
